<template>
  <div class="pc_container app-main-content">
    <leftSlider :list="leftList" :check="4"></leftSlider>
    <div class="app-main-content-section bgfff c266">
      <div class="page_title">修改密码</div>
      <div class="box1 box flex flex_column">
        <div class="flex flex_items mb24">
          <div class="label-items"><span class="color-red">*</span> 原密码</div>
          <div>
            <el-input placeholder="请输入" v-model="old_password" type="password" class="w400"></el-input>
          </div>
        </div>
        <div class="flex flex_items mb24">
          <div class="label-items"><span class="color-red">*</span> 新密码</div>
          <div>
            <el-input placeholder="请输入" v-model="password" type="password" class="w400"></el-input>
          </div>
        </div>
        <div class="flex flex_items">
          <div class="label-items"><span class="color-red">*</span> 再次输入密码</div>
          <div>
            <el-input placeholder="请输入" v-model="password_confirmation" type="password" class="w400"></el-input>
          </div>
        </div>

        <div class="flex flex_items mt40">
          <div class="label-items"></div>
          <div class="w400">
            <div class="dialog-footer flex flex_items f14">
              <div class="sub_btn page_main_bg cf" @click="handleSure">立即提交</div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
import leftSlider from '@/components/leftSlider/leftSlider'
import leftList from './utils/list'
import { PUBLICURL } from '@/utils/index'
import { getRoleArr } from '@/utils/tool';
import { phoneCheck } from '@/utils/public'
import UploadFile from '@/components/uploadFile.vue';
import { exportUrl } from '@/utils/downloadUrl'
import bread from '@/utils/breadList'

export default {
  data() {
    return {
      PUBLICURL: PUBLICURL,
      check: 0,
      leftList: leftList,
      dialogVisible: false,
      keyword: '',
      role: getRoleArr,
      old_password: '',

      password_confirmation: '',
      password: '',

      handleId: '',




    };
  },
  components: { leftSlider, UploadFile },
  watch: {

  },
  methods: {
    handleSure() {
      if(!this.old_password){
        return this.$message.error('请输入原密码')
      }
      if(!this.password || this.password != this.password_confirmation){
        return this.$message.error('密码不能为空或两次输入密码不一致')
      }
      let obj = {
        password_confirmation:this.password_confirmation,
        password:this.password,
        old_password:this.old_password
      }
      this.api.postUrl('/api/manage/system/password', obj, { loading: true })
        .then((res) => {
          this.$message.success('修改成功')
        });
    },
  },
  created() {
    this.$store.dispatch('app/setBreadListMutations', bread(4, '', '修改密码'))
    this.leftList = leftList;

    // this.addNew()
  },
};
</script>
<style scoped>
.list-items {
  width: 266px;
  height: 150px;
  background: #F5F7FA;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.page_title {
  margin-bottom: 24px;
}

.w400 {
  width: 400px;
}

.label-items {
  text-align: right;
  margin-right: 12px;
  font-size: 14px;
}

.box1 .label-items {
  width: 100px;
}

.box2 .label-items {
  width: 182px;
}

.box {
  margin-bottom: 48px;
}
</style>
<style>
.el-progress__text {
  font-size: 13px !important;
}
</style>